let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j09Vp")).then(() => parcelRequire('4qzdE'));